const JobStatus = {
  IN_CREATION: 0,
  IN_PROGRESS: 1,
  DONE: 2,
};

export default JobStatus;
